import { person as defs } from './baseClass';
export { person } from './mods/';
export { defs };
